(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brasecret-text-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bsr-reviews')) {
  customElements.define('bsr-reviews', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.wrap = this.querySelector('[data-arrows]');
      if (!this.track || !this.wrap) return;
      this.prev = this.wrap.querySelector('[data-prev]');
      this.next = this.wrap.querySelector('[data-next]');
      this.sign = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
      this.prev.addEventListener('click', () => this.move(-1));
      this.next.addEventListener('click', () => this.move(1));
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      window.addEventListener('resize', () => this.update());
      this.update();
    }
    move(d) {
      const card = this.track.querySelector('.bsr__card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({ left: d * this.sign * (card.offsetWidth + gap) });
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const pos = Math.abs(this.track.scrollLeft);
      this.wrap.hidden = max <= 2;
      this.prev.disabled = pos <= 2;
      this.next.disabled = pos >= max - 2;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
